module.exports = __webpack_public_path__ + "img/card6.0476aceb.png";